import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Map',
    component: () => import(/* webpackChunkName: "map" */ '../views/Map.vue')
  }, {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/protected',
    name: 'Protection',
    component: () => import(/* webpackChunkName: "protected" */ '../views/Protected.vue')
  }, {
    path: '/mobile',
    name: 'Mobile',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/Mobile.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let is_mobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  if (is_mobile && to.name != "Mobile") {
    next('/mobile')
  } else if (!is_mobile && to.name == "Mobile") {
    next('/')
  } else {
    if (to.meta.requiresAuth) {
      if (!localStorage.getItem('admin-pwd') || localStorage.getItem('admin-pwd') != process.env.VUE_APP_PROTECTED_PASSWORD) next('/protected')
      else next()
    } else next()
  }
})

export default router
